module.exports = __webpack_public_path__ + "static/media/IMG_1337.550415ce.jpg";